import { BridgeComponent } from "@hotwired/hotwire-native-bridge";

// A provider's door inside the native shell: the system browser, not the web
// view (docs/DOORS.md § Sign in inside the shell). The page asks the server
// for a state kept in this session, then tells the shell where to go; the
// shell hands the callback URL back to the web view as /auth/native/exchange.
// On the plain web, or in a shell without the component, `enabled` is false
// and the button's form posts to omniauth as always.
export default class extends BridgeComponent {
  static component = "oauth";
  static values = { provider: String };

  async start(event) {
    if (!this.enabled) return;
    event.preventDefault();

    const res = await fetch("/auth/native/nonce", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
          ?.content,
      },
      body: "{}",
    });
    if (!res.ok) return;
    const { state } = await res.json();

    const url = new URL("/auth/native/start", window.location.origin);
    url.searchParams.set("provider", this.providerValue);
    url.searchParams.set("state", state);
    this.send("start", { url: url.toString() });
  }
}
